module.exports = __webpack_public_path__ + "img/IC_Vacaciones_Rechazada.9e2f04f4.svg";